import script from "./welcome2.vue?vue&type=script&setup=true&lang=js"
export * from "./welcome2.vue?vue&type=script&setup=true&lang=js"

import "./welcome2.vue?vue&type=style&index=0&id=d5c524c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5c524c6"]])

export default __exports__